import React from "react"
import { CardBody } from "reactstrap"

const COLORS = [
  "#4361ee",
  "#22c55e",
  "#f59e0b",
  "#a855f7",
  "#ef4444",
  "#2DD4BF",
  "#F472B6",
  "#60A5FA",
  "#FB923C",
  "#34D399",
]

const CategoryProgressChart = ({ data = [] }) => {
  const total = data?.reduce(
    (sum, i) => sum + Number(i.totalWeeklySalesValue),
    0
  )

  const dataWithPercent = data
    .map((i, index) => ({
      ...i,
      color: COLORS[index % COLORS.length], // ← assign color by index
      percent: ((Number(i.totalWeeklySalesValue) / total) * 100).toFixed(1),
    }))
    .sort(
      (a, b) =>
        Number(b.totalWeeklySalesValue) - Number(a.totalWeeklySalesValue)
    )

  if (!data?.length) return null

  return (
    <div className="bg-light card rounded-4">
      <CardBody>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h5
              className="mb-1 fw-bold"
              style={{ color: "#1a1a2e", fontSize: "18px" }}
            >
              Revenue by Category
            </h5>
            <small style={{ color: "#444", fontSize: "14px", fontWeight: 500 }}>
              Overall contribution breakdown
            </small>
          </div>
          <div
            style={{
              background: "#eef0fb",
              color: "#4361ee",
              borderRadius: "8px",
              padding: "4px 14px",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            Total: <strong>£{Math.round(Number(total)).toLocaleString("en-GB")}</strong>
          </div>
        </div>

        {/* Progress Bars */}
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {dataWithPercent.map((item, i) => (
            <div key={i}>
              {/* Label row */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: item.color,
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#1a1a2e",
                    }}
                  >
                    {item.subCategoryName || "-"}
                  </span>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <span
                    style={{ fontSize: "14px", color: "#222", fontWeight: 500 }}
                  >
                    £
                    {Math.round(item.totalWeeklySalesValue).toLocaleString("en-GB")}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 700,
                      color: item.color,
                      minWidth: "40px",
                      textAlign: "right",
                    }}
                  >
                    {item.percent}%
                  </span>
                </div>
              </div>

              {/* Progress bar */}
              <div
                style={{
                  height: "8px",
                  background: `${item.color}22`, // ← light tinted background
                  borderRadius: "99px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${item.percent}%`,
                    background: item.color,
                    borderRadius: "99px",
                    transition: "width 0.8s ease",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Footer summary */}
        <div
          className="d-flex justify-content-between mt-4 pt-3"
          style={{ borderTop: "1px solid #f0f0f0" }}
        >
          <small style={{ color: "#444", fontSize: "13px", fontWeight: 500 }}>
            {dataWithPercent.length} categories
          </small>
          <small style={{ color: "#444", fontSize: "13px", fontWeight: 500 }}>
            Top:{" "}
            <strong style={{ color: dataWithPercent[0]?.color }}>
              {dataWithPercent[0]?.subCategoryName} (
              {dataWithPercent[0]?.percent}%)
            </strong>
          </small>
        </div>
      </CardBody>
    </div>
  )
}

export default CategoryProgressChart
